import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SipHeadersService} from '../../../../services/common/sip-headers/sip-headers.service';
import * as _ from 'lodash';

@Component({
  selector: 'sip-custom-value',
  templateUrl: './sip-custom-value.component.html',
  styleUrls: ['./sip-custom-value.component.scss']
})
export class SipCustomValueComponent implements OnInit {

  @Output() onApply = new EventEmitter<any>();
  @Input() group;

  customConditionValues: any = [''];
  subjectSuggestions;
  headerStructure;

  constructor(private sipHeadersService: SipHeadersService) { }

  ngOnInit(): void {
    this.updateSubjectSuggestions();

    this.sipHeadersService.getSipConditionTemplate().subscribe(sipConditionData => {
      this.headerStructure = sipConditionData.headerStructure;
    });
  }

  addCustomConditionValue(): void {
    this.customConditionValues.push('');
  }

  updateSubjectSuggestions($event: any = ''): void {
    this.subjectSuggestions = this.sipHeadersService.generateSubjectSuggestions($event);
  }

  removeCustomConditionValue(index): void {
    this.customConditionValues.splice(index, 1);
  }

  generateCustomValue(): string {
    if (!this.headerStructure || !this.customConditionValues) { return ''; }

    return this.customConditionValues.map(value => {
      const headerType = value.substring(0, value.lastIndexOf('.')).toLowerCase();
      const headerExist = this.headerStructure.indexOf(value) > -1;
      const allowFreeText = !_.isNil(this.headerStructure
        .find(header => header.toLowerCase() === `${headerType}.otherheader` || header.toLowerCase() === `${headerType}.fieldname`));

      return (headerExist || allowFreeText) ? value : `'${value}'`;
    }).join(' + ');
  }

  trackByIdx(index: number): any {
    return index;
  }

  private resetCustomValue(condition): void {
    this.customConditionValues = [''];
    condition.isCustomValueOpen = false;
  }

  isValidCustomValue(): boolean {
    return this.customConditionValues.some(value => _.isEmpty(value));
  }

  onAddValueApply(): void {
    const customValue = this.generateCustomValue();

    this.closeCustomValue();
    this.onApply.emit({ customValue, group: this.group });
  }

  onAddValueCancel(): void {
    this.closeCustomValue();
  }

  private closeCustomValue(): void {
    this.group.isCustomValueOpen = false;
    this.group.isCustomSuffixOpen = false;
  }

}
